"use strict";
var links = {
    LINK_HOMEPAGE: "https://www.pracuj.pl/",
    LINK_JOB_OFFERS: "https://www.pracuj.pl/praca",
    LINK_JOB_SUPEROFFERS: "https://www.pracuj.pl/praca/true;so",
    LINK_FIRST_JOB: "https://www.pracuj.pl/praca?et=3%2c1",
    LINK_EMPLOYERS: "https://pracodawcy.pracuj.pl/",
    LINK_CV_CREATOR: "https://cv.pracuj.pl/",
    LINK_CODEJOBS: "https://it.pracuj.pl/",
    LINK_TIPS: "https://porady.pracuj.pl/",
    LINK_SALARIES: "https://zarobki.pracuj.pl/",
    LINK_FOR_EMPLOYERS: "https://dlafirm.pracuj.pl/",
    LINK_ADVICE_FOR_EMPLOYERS: "https://poradydlafirm.pracuj.pl/",
    LINK_LOGIN: "https://login.pracuj.pl/",
    LINK_LOGOUT: "https://www.pracuj.pl/wylogowanie",
    LINK_REGISTER: "https://www.pracuj.pl/zaloz-konto",
    LINK_PROFILE: "https://profil.pracuj.pl/",
    LINK_ACCOUNT: "https://www.pracuj.pl/apps#/konto/",
    LINK_SAVED_OFFERS: "https://www.pracuj.pl/apps/konto/zapisane-oferty",
    LINK_MESSENGER: "https://www.pracuj.pl/apps/konto/wiadomosci",
    LINK_RECOMMENDED_OFFERS: "https://www.pracuj.pl/apps/konto/rekomendowane-oferty",
    LINK_MY_SEND_JOB_REQUESTS: "https://www.pracuj.pl/apps/konto/moje-aplikacje",
    LINK_JOB_ALERTS: "https://www.pracuj.pl/apps/konto/job-alerts",
    LINK_DOCS: "https://www.pracuj.pl/apps/konto/cv-i-inne-dokumenty",
    LINK_SETTINGS: "https://www.pracuj.pl/apps/konto/ustawienia",
    LINK_SALARIES_REPORT: "https://zarobki-raport.pracuj.pl/#!/survey/step-0",
    LINK_SALARIES_CALCULATOR: "https://zarobki.pracuj.pl/kalkulator-wynagrodzen",
    LINK_JOBICON: "https://jobicon.pracuj.pl/",
    LINK_THE_PROTOCOL: "https://theprotocol.it/",
    LINK_DRYG: "https://dryg.pl/",
    LINK_EMPLOYERS_PROFILES: "https://pracodawcy.pracuj.pl",
    LINK_HIRE: "https://pracujwgp.pl/",
    LINK_RABOTA: "https://rabota.ua/",
    LINK_LABOR_OFFICES: "https://urzedy-pracy.pracuj.pl/",
    LINK_ADD_OFFER: "https://dlafirm.pracuj.pl/?prlc=b2c_stopka&prnm=sekcja_b2c",
    LINK_EMPLOYER_PROFILE: "https://dlafirm.pracuj.pl/sklep/",
    LINK_EMPLOYER_HELP: "https://dlafirm.pracuj.pl/pomoc",
    LINK_ABOUT: "https://grupapracuj.pl/firma/",
    LINK_PRESS: "https://media.pracuj.pl/",
    LINK_ADS: "https://reklama.pracuj.pl/",
    LINK_PARTNERS: "https://porady.pracuj.pl/partnerzy/",
    LINK_OFFERS_ARCHIVE: "https://archiwum.pracuj.pl/",
    LINK_HELP: "https://pomoc.pracuj.pl/hc/pl",
    LINK_REGULATIONS: "https://grupapracuj.pl/grupa-kapitalowa/regulamin",
    LINK_PRIVACY_POLICY: "https://grupapracuj.pl/polityka-prywatnosci",
    LINK_COOKIES_POLICY: "https://grupapracuj.pl/grupa-kapitalowa/polityka-plikow-cookie",
    LINK_COOKIES_PARTNERS: "https://grupapracuj.pl/prywatnosc/partnerzy-cookies/",
    LINK_COOKIES_DATA_COLLECTION_POLICY: "https://grupapracuj.pl/grupa-kapitalowa/polityka-plikow-cookie#6",
    LINK_GOOGLE_PLAY_APP: "https://play.google.com/store/apps/details?id=pl.pracuj.android.jobsearcher&referrer=utm_source%3Dpracuj%26utm_medium%3Dbutton%26utm_campaign%3Dstopka",
    LINK_APPSTORE_APP: "https://itunes.apple.com/pl/app/id386774884",
    LINK_FACEBOOK: "https://www.facebook.com/pracuj",
    LINK_YOUTUBE: "https://www.youtube.com/user/pracuj",
    LINK_INSTAGRAM: "https://www.instagram.com/pracuj.pl/",
    LINK_GRUPA_PRACUJ: "https://grupapracuj.pl",
    LINK_THE_NETWORK: "https://www.pracuj.pl/pracodawca-partnerzy-network.htm",
    LINK_E_RECRUITER: "https://go.erecruiter.pl/cr-umow-sie-na-prezentacje-pr",
    LINK_E_RECRUITER_BLOG: "https://erecruiter.pl/blog/",
    LINK_JOB_OFFERS_UA: "https://robota.pracuj.pl/"
};
module.exports = links;
